import {
  Component, Input, ViewEncapsulation, Output, EventEmitter
} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { AirValidationResponseVm } from '@app/entities/air-validation.response';
import { SectorTripNumber } from '@user-history/entities/user-history-item';
import { loaderColors } from '@ux/entities/loader-colors';
import { TravelDetailProvider } from '@shared/flight-itinerary/entities/travel-detail-provider';
import { isNullOrUndefined } from '@app/util/util';

@Component({
  selector: 'app-travel-segment-detail',
  templateUrl: './travel-segment-detail.component.html',
  styleUrls: ['./travel-segment-detail.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: false
})
export class TravelSegmentDetailComponent {

  @Input() validationVm: AirValidationResponseVm;
  @Input() summaryProvider: TravelDetailProvider;
  @Input() isPackageBookingResume: boolean;
  @Input() upsellLoading: boolean;
  @Input() showUpsell: boolean = false;
  @Input() baggage: boolean = false;
  @Input() upsellSelected: boolean = false;
  @Input() fareFamilies: string = null;
  @Input() noShadow: boolean;
  @Input() isMobile: boolean;
  @Input() isFlightBySector: boolean = false;
  @Input() isFirst: boolean = false;
  @Input() isLast: boolean = false;
  @Input() index: number = null;
  @Input() isInternational: boolean;
  
  @Output() showFlightDetail: EventEmitter<{ validator: AirValidationResponseVm, sectorNumber: number }> = new EventEmitter();
  @Output() openUpsell: EventEmitter<void> = new EventEmitter();

  public loaderColor: string = loaderColors.GRAY;

  private departureSectorNumber: SectorTripNumber = SectorTripNumber.DEPARTURE;
  private arrivalSectorNumber: SectorTripNumber = SectorTripNumber.RETURN;

  constructor(private translate: TranslocoService) { }

  get headerTitle(): string {
    return this.isFlightBySector ? this.bySectorHeader : this.translate.translate('BOOKING_MODULE.FLIGHT_TRIP.YOUR_TRIP');
  }

  get bySectorHeader(): string {
    if (this.isFirst && this.isLast) {
      return this.translate.translate('BOOKING_MODULE.FLIGHT_TRIP.YOUR_TRIP');
    } else if (this.isFirst) {
      return this.translate.translate('FLIGHT_RESULTS_MODULE.UPSELL.OUTBOUND_FLIGHT');
    } else if (this.isLast) {
      return this.translate.translate('FLIGHT_RESULTS_MODULE.UPSELL.RETURN_FLIGHT');
    } else return this.translate.translate('BOOKING_MODULE.FLIGHT_TRIP.SECTOR', { sector: this.index + 1 });
  }

  get baggageImproveMessage(): string {
    return !this.baggage ? 'IMPROVE_YOUR_FLIGHT_NOT_BAGGAGE' : 'IMPROVE_YOUR_FLIGHT_WITH_BAGGAGE';
  }

  public isOneWay(first: boolean, last: boolean): boolean {
    return first && last;
  }

  public defaultSectorNumber(sectorNumber: number = null): number {
    if (this.isPackageBookingResume) {
      return !isNullOrUndefined(sectorNumber) ? sectorNumber : this.departureSectorNumber;
    } else {
      return this.isFlightBySector ? (this.isFirst ? this.departureSectorNumber : this.arrivalSectorNumber) :
        (!isNullOrUndefined(sectorNumber) ? sectorNumber : null);
    }
  }
}
